import * as React from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Container, Card, CardContent, Typography, Button, Box } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import ErrorIcon from '@mui/icons-material/Error';

const theme = createTheme();

function TokenDisplay() {
  const [token, setToken] = React.useState("No token found");
  const [copyStatus, setCopyStatus] = React.useState('idle'); // 'idle', 'success', 'error'

  React.useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const codeParam = params.get('code');
    if (codeParam) {
      setToken(codeParam);
    }
  }, []);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(token).then(() => {
      setCopyStatus('success');
      setTimeout(() => setCopyStatus('idle'), 2000); // Reset after 2 seconds
    }).catch(err => {
      console.error('Failed to copy text: ', err);
      setCopyStatus('error');
      setTimeout(() => setCopyStatus('idle'), 2000); // Reset after 2 seconds
    });
  };

  const getButtonContent = () => {
    switch (copyStatus) {
      case 'success':
        return (
          <>
            <CheckIcon sx={{ mr: 1 }} />
            Copied!
          </>
        );
      case 'error':
        return (
          <>
            <ErrorIcon sx={{ mr: 1 }} />
            Error!
          </>
        );
      default:
        return (
          <>
            <ContentCopyIcon sx={{ mr: 1 }} />
            Copy
          </>
        );
    }
  };

  return (
    <Container maxWidth="false">
      <Card sx={{ mt: 4 }}>
        <CardContent>
          <Typography variant="h4" component="h1" gutterBottom>
            Kubernetes Login Token
          </Typography>
          <Box sx={{
            bgcolor: 'grey.100', p: 2, borderRadius: 1,
            display: 'flex', alignItems: 'center',
            justifyContent: 'space-between',
          }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="body1" component="p" sx={{ fontFamily: 'monospace', overflowWrap: 'anywhere', mr: 2, flexGrow: 1 }}>
                {token}
              </Typography>

              <Button
                onClick={copyToClipboard}
                variant="contained"
                color={copyStatus === 'success' ? 'success' : copyStatus === 'error' ? 'error' : 'primary'}
                sx={{ whiteSpace: 'nowrap', transition: 'background-color 0.2s', minWidth: 'auto' }}
              >
                {getButtonContent()}
              </Button>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <TokenDisplay />
    </ThemeProvider>
  );
}

const root = createRoot(document.getElementById("root"));
root.render(<App />);
